import { Injectable } from '@angular/core';
import { WindowService } from '../shared/window.service';

import { HttpClient } from '@angular/common/http';
import { TokenService } from '../shared/token.service';

export const SHARING_ACCOUNT_PENDING_VALIDATION_KEY = '__oe_sharing_account_pending_validation';
export const SHARING_ACCOUNT_URL_KEY = '__oe_sharing_account_url';

@Injectable()
export class SharedAccountService {
  constructor(
    private readonly windowService: WindowService,
    private readonly http: HttpClient,
    private readonly tokenService: TokenService
  ) {}

  public init() {
    const isPendingValidation = JSON.parse(sessionStorage.getItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY));
    const url = sessionStorage.getItem(SHARING_ACCOUNT_URL_KEY);
    this.accountSharingGuard(isPendingValidation, url);
  }

  public accountSharingGuard(isPendingValidation: boolean, url: string) {
    const isInValidationPage = this.windowService.getHref().includes('/account-sharing.html');
    const tempToken = this.tokenService.tempToken;
    const ssoToken = this.tokenService.token;
    const isTempTokenExpired = this.tokenService.isTempTokenExpired;

    // If the user is in the validation page and there is no temp token or the sso token is already set, redirect to the home/login page
    if (isInValidationPage && (!tempToken || ssoToken || isTempTokenExpired)) {
      this.windowService.redirectToUrl('/');
    }

    if (isPendingValidation && !isInValidationPage) {
      this.windowService.redirectToUrl('/account-sharing.html');
      this.setSharingAccountPendingValidationValue(true);
      this.setSharingAccountUrlValue(url || '/');
    }
  }

  public setSharingAccountPendingValidationValue(isPendingValidation: boolean) {
    sessionStorage.setItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY, JSON.stringify(isPendingValidation));
  }

  public removeSharingAccountPendingValidationValue() {
    sessionStorage.removeItem(SHARING_ACCOUNT_PENDING_VALIDATION_KEY);
  }

  public updateAccountSharingAccessToken$(accessToken: string) {
    return this.http
      .post(
        '/sso-cookies',
        { accessToken },
        {
          headers: {
            Authorization: `Bearer ${this.tokenService.tempToken}`,
          },
        }
      );
  }

  public setSharingAccountUrlValue(url: string) {
    sessionStorage.setItem(SHARING_ACCOUNT_URL_KEY, url);
  }

  public removeSharingAccountUrlValue() {
    sessionStorage.removeItem(SHARING_ACCOUNT_URL_KEY);
  }

  public getSharingAccountUrlValue() {
    return sessionStorage.getItem(SHARING_ACCOUNT_URL_KEY);
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/shared-account.service.ts